function initCheckoutConfirmationPage() {
  initCheckoutConfirmationPageClickHandler();
}

initCheckoutConfirmationPage();

/* define all click Handlers here */
function initCheckoutConfirmationPageClickHandler() {
  const orderDetailViewClickController = document.getElementById(
    "order-confirmation-detail-view-click-handler",
  );

  const orderDetailView = document.getElementById(
    "checkout-order-detail-controller",
  );

  if (!orderDetailViewClickController || !orderDetailView) return;

  type OrderDetailViewStates = "open" | "close";

  orderDetailViewClickController.addEventListener("click", () => {
    const states = {
      open: "close",
      close: "open",
    };

    const currentState = orderDetailView.getAttribute(
      "data-state",
    ) as OrderDetailViewStates;

    orderDetailView.setAttribute("data-state", states[currentState]);
  });
}
